import { useEffect, useState } from 'react';
import { useFormState } from 'react-hook-form';

import { trackEvent, trackPage } from 'lib/tracking';

export const useTrackPage = (page: string) => {
  useEffect(() => trackPage(page), [page]);
};

export const useTrackFormTouched = (formType: string) => {
  const [isTouched, setTouched] = useState<boolean>(false);
  const formState = useFormState();

  if (formState.isDirty && !isTouched) {
    setTouched(true);
    trackEvent('user', 'input', 'touch-form', { type: formType });
  }
};
